module.exports = __webpack_public_path__ + "static/media/no-items.492fa9ea.svg";